import { defineComponent, h } from 'vue';
import { Vue } from '@/Shared/vueCompat.js';
import { QCheckbox, QIcon, QTooltip } from 'quasar';
import BaseComponent from './BaseComponentMixin.jsx';
import careHelpfulFunctions from '../careHelpfulFunctions.jsx';
import TranslationContainer from './TranslationContainer.jsx';

import utils from '../../Shared/utils.jsx';

export default defineComponent({
    name: 'checkbox',
    mixins: [BaseComponent],
    components: {
        TranslationContainer,
        QCheckbox,
        QIcon,
        QTooltip,
    },
    data: function () {
        return {
            thisproxy: null,
            setValueFunction: null,
            isDisabledEval: null,
            tooltipEval: null,
            labelEval: null,
            value: false,
        };
    },
    created() {
        //if (!this.todisplay)
        //    return;

        //if (this.controlData.Default == null)
        //    this.value = false;
        //else
        //    this.value = !!(utils.evaluate(utils.compileExpression(this, this.controlData.Default), this));
    },
    computed: {
        label() {
            try {
                if (this.labelEval === null && this.controlData.Label)
                    this.labelEval = utils.compile(this, this.Translate(this.controlData.Label));
                if (this.labelEval)
                    return utils.evaluate(this.labelEval, this);
                return '';
            }
            catch (e) {
                utils.warn('Label could not evaluate expression: ' + this.controlData.Label + '; ' + e);
                return '';
            }
        },
        tooltip() {
            try {
                if (this.tooltipEval === null && this.controlData.Tooltip)
                    this.tooltipEval = utils.compile(this, this.Translate(this.controlData.Tooltip));
                if (this.tooltipEval)
                    return utils.evaluate(this.tooltipEval, this);
                return '';
            }
            catch (e) {
                utils.warn('Tooltip could not evaluate expression: ' + this.controlData.Tooltip + '; ' + e);
                return '';
            }
        },
        isDisabled() {
            try {
                if (this.isDisabledEval === null && this.controlData.IsDisabled)
                    this.isDisabledEval = utils.compile(this, this.Translate(this.controlData.IsDisabled));
                if (this.isDisabledEval)
                    return utils.evaluate(this.isDisabledEval, this) == 'true';
                return false;
            }
            catch (e) {
                utils.warn('IsDisabled could not evaluate expression: ' + this.controlData.IsDisabled + '; ' + e);
                return false;
            }
        },
        publishField: {
            set(value) {
                console.log(`Checkbox publishField value:${value}`);

                if (this.setValueFunction === null && this.controlData.PublishField) {
                    const vueSet = `${this.controlData.PublishField} = realvalue`;
                    this.setValueFunction = new Function('realvalue', 'context', 'util', `with (context) { ${vueSet}; console.log('value is ' + realvalue); }`);
                    this.thisproxy = utils.helpers.getWithProxy(this);
                }
                if (this.setValueFunction)
                    this.setValueFunction(value, this.thisproxy.proxy, careHelpfulFunctions);
                this.value = value;
            },
            get() {
                return this.value;
            },
        },
        checkboxStyles() {
            return {
                ...utils.resolveStyleHints(this.styleHints, this),
            };
        },
    },
    methods: {
        async onChange(value) {
            const v = value === true;
            this.publishField = v;
            await utils.executeAndCompileAllActions(this.controlData.OnChangeActions, { Data: v }, this);
        },
        preRenderComplete() {
            this.finishRenderHandler(this);

            if (this.todisplay) {
                if (this.controlData.Default == null)
                    this.value = false;
                else
                    this.value = !!(utils.evaluate(utils.compileExpression(this, this.controlData.Default), this));
            }
        },
        SetCheckboxValue(value) {
            const v = value === true || value === 'true';
            return this.onChange(v);
        },
    },
    render() {
        if (!this.todisplay)
            return null;

        try {
            const showInfoIcon = !!this.tooltip;
            const defaultSlotContent = showInfoIcon
                ? [
                    <TranslationContainer key="label" context={this} value={this.label}></TranslationContainer>,
                    <QIcon key="hint" size="xs" class="q-pl-sm form-hint-icon" name="mdi-information">
                        <QTooltip transition-show="scale" transition-hide="scale" class="text-body2">
                            {utils.renderTooltipContent(this.tooltip)}
                        </QTooltip>
                    </QIcon>,
                ]
                : <TranslationContainer key="label" context={this} value={this.label}></TranslationContainer>;

            // ensure control fits within ag-grid
            const isContentDef = this.parentType === 'ContentDef';

            return (
                <div
                    class={{ 'c-Checkbox': true, [`c-name-${this.name || 'unnamed'}`]: true }}
                    v-show={this.isvisible}
                    style={this.sizeStyle}
                >
                    <QCheckbox
                        dense
                        class={isContentDef ? 'q-ma-none' : 'q-ma-xs'}
                        modelValue={this.value}
                        onUpdate:modelValue={this.onChange}
                        disable={this.isDisabled}
                        style={this.checkboxStyles}
                    >
                        {{ default: () => defaultSlotContent }}
                    </QCheckbox>
                </div>
            );
        }
        catch (e) {
            utils.error('Checkbox Render failed', e);
            return <div>Checkbox Failed to Render {e}</div>;
        }
    },
});
